import TeamSearchContainer from './TeamSearchContainer';

export default TeamSearchContainer;
